import { render, staticRenderFns } from "./Sequence-based.vue?vue&type=template&id=33e7c506&scoped=true"
import script from "./Sequence-based.vue?vue&type=script&lang=js"
export * from "./Sequence-based.vue?vue&type=script&lang=js"
import style0 from "./Sequence-based.vue?vue&type=style&index=0&id=33e7c506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7c506",
  null
  
)

export default component.exports